export const ProjectSpecialistStatus = Object.freeze({
    RESPONDED: "responded",
    IN_PROGRESS: "in_progress",
    COMPLETED: "completed",
    ARCHIVED: "archived",
    CANCELLED: "cancelled",
});
